<template>
  <div class="">
    <el-container>
      <el-main>
        <div class="box">
          <el-form ref="form" :inline="true" label-width="100px" size="small">
            <el-form-item>
              <el-input v-model.trim="queryTask.taskName" placeholder="请输入类型名称" />
            </el-form-item>
            <el-form-item>
              <el-date-picker style="padding-left:3px" v-model="queryTask.selectDatetimest" type="datetime" placeholder="选择查询时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <div>
            <el-button plain size="small" @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
          </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                  :cell-style="{height:'5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column label="任务名"  prop="taskName"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" min-width="100%">
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间" min-width="100%">
          </el-table-column>
          <el-table-column prop="auth" label="创建人" min-width="100%">
          </el-table-column>
          <el-table-column label="任务进度" >
            <template slot-scope="scope">
              <div v-if="scope.row.progress==='7%'">
                <span style="color: cornflowerblue">任务执行中</span>
              </div>
              <div v-if="scope.row.progress==='100%'">
                <span style="color: green">任务成功</span>
              </div>
              <div v-if="scope.row.progress==='-5%'">
                <span style="color: red">任务失败</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <div v-if="scope.row.progress==='7%'">
                <a  href="###" disabled="display">下载</a>
              </div>
              <div v-if="scope.row.progress==='100%'">
                <a  :href="descPath+scope.row.url">下载</a>
              </div>
              <div v-if="scope.row.progress==='-5%'">
                <a  href="#" disabled="display">下载</a>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>

  </div>

</template>

<script>

import Pagination from '../../../components/pagination'

export default {
  name: 'task_list',
  components: {
    Pagination,
  },
  mounted: function () {

  },
  data() {
    return {
      queryTask:{
        taskName:'',
        currentPage:1,
        pageSize: 10,
        selectDatetimest: '',
      },
      descPath: 'http://' + location.host,
      ORDER_BY_rule: '1',
      ORDER_BY_type: '1',
      tableData: [],
      taskJs: require('../../../api/task')
    }
  },
  methods: {
    dataSearchSt(data) {
      this.queryTask.selectDatetimest=data
    },

    list(page) {
      let _this = this
      _this.queryTask.currentPage =page
      _this.queryTask.pageSize = _this.$refs.pagination.size
      _this.taskJs.taskList(_this.queryTask)
      .then(res=>{
        if(res.data.code==='0'){
          _this.tableData = res.data.data.rows
          _this.$refs.pagination.render(page,res.data.data.total)
        }else{
          _this.$alert(res.data.msg)
        }
      })
    },

  }
}
</script>

<!--<style scoped>-->
<style  lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }

/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btns {
  margin-left: 30px;
  margin-top: 0px !important;
}
/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}

.my_checkbox__inner {
  border: none;
}

.my_checkbox__label {
  padding-left: 5px;
}

.my_checkbox {
  margin-right: 15px;
}

.el-table td,
.el-table th.is-leaf {
  padding: 0px !important;
}

.el-table td,
.el-table th {
  padding: 0px !important;
}

.el-form-item label {
  font-size: 16px;
}

.el-form-item__label .wrapper {
  color: red;
}

._select {
  width: 20%;
  height: 34px;
}

.pup {
  float: right;
}

.col-md-3 {
  float: left;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.float_right {
  float: right;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
}

.el-form-item {
  margin-bottom: 0px;
}

</style>

